export const DEFAULT_CARGO_ORIGINAL_NAME = 'CRUDE OIL';
export const DEFAULT_QTY_UNIT = 'MTS';
